import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import IconButton from 'components/IconButton';
import closeIcon from 'assets/icons/close-button.svg';

import './styles.css';

interface PassedProps {
  tabs: Array<{
    url: string;
    ref: string;
    label: string; // used for rightsidebar__contentHeader
    count?: number;
  }>;
  children: React.FunctionComponent<{openedTab: string}>;
}

class RightSideBar extends React.Component<PassedProps> {
  state = {
    isOpened: false,
    openedTab: ''
  };

  openTab = ref => {
    this.setState({isOpened: true, openedTab: ref});
  };

  closeRightSideBar = () => {
    this.setState({isOpened: !this.state.isOpened, openedTab: ''});
  };

  getOpenedTab = () => {
    return _.first(
      this.props.tabs.filter(tab => tab.ref === this.state.openedTab)
    );
  };

  render() {
    const {tabs, children} = this.props;
    const activeTab = this.getOpenedTab();

    return (
      <div
        className={classNames('RightSideBar', {
          'RightSideBar--opened': this.state.isOpened
        })}>
        <div className="RightSideBar__navigation">
          {tabs.map(tab => (
            <div
              key={tab.ref}
              className="RightSideBar__tab"
              title={tab.label}
              onClick={() => this.openTab(tab.ref)}>
              <IconButton src={tab.url} alt="" />
              {!_.isUndefined(tab.count) &&
                tab.count > 0 && (
                  <div className="RightSideBar__navigation__countContainer colab-centered">
                    <div className="RightSideBar__navigation__count colab-bold">
                      {tab.count}
                    </div>
                  </div>
                )}
            </div>
          ))}
        </div>
        <div className="RightSideBar__content">
          {activeTab && (
            <div className="RightSideBar__contentHeader colab-row-space-between colab-bold colab-sidepadding-2 colab-centered-v">
              <div>{activeTab.label}</div>
              <IconButton
                src={closeIcon}
                alt="Close right side bar"
                onClick={this.closeRightSideBar}
              />
            </div>
          )}
          {children({openedTab: this.state.openedTab})}
        </div>
      </div>
    );
  }
}

export default RightSideBar;
